<div class="overlay-blocker">
  <div class="overlay-blocker__content">
    <div class="overlay-blocker__spinner animate-spin">
      <svg-icon
        src="/assets/icons/loader.svg"
        [svgStyle]="{
          width:
            spinnerSize() === 'sm'
              ? '32px'
              : spinnerSize() === 'md'
                ? '48px'
                : '64px',
          height:
            spinnerSize() === 'sm'
              ? '32px'
              : spinnerSize() === 'md'
                ? '48px'
                : '64px',
          fill: 'currentColor'
        }"
        class="animate-spin"
      ></svg-icon>
    </div>
    @if (message()) {
      <p class="overlay-blocker__message">{{ message() }}</p>
    }
    @if (description()) {
      <p class="overlay-blocker__description">{{ description() }}</p>
    }
  </div>
</div>
